import giftCardsSlice from './slice';

export default giftCardsSlice.reducer;
